// @flow
import Input from './Input'
import InputFormGroup from './InputFormGroup'
import InputFormGroupField from './InputFormGroupField'

export { Input, InputFormGroup }
export default InputFormGroupField
